/*eslint-disable*/
import React from 'react';
// reactstrap components
import { Container, Modal, ModalBody } from 'reactstrap';
import AddFeedback from "../../views/forms/animoFeedback/AddFeedback.jsx";
class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AddFeedback: false,
    }
    this.toggleAddFeedback = this.toggleAddFeedback.bind(this);
  }
  toggleAddFeedback() {
    this.setState({
      AddFeedback: !this.state.AddFeedback,
    });
  }
  render() {
    return (
      <footer className="footer">
        <Modal
          isOpen={this.state.AddFeedback}
          toggle={this.toggleAddFeedback}
          size="lg" modalClassName="modal-black"
        >
          <ModalBody>
            <AddFeedback
              toggle={() => this.toggleAddFeedback()}
              closeModal={() => this.toggleAddFeedback()}
            >
            </AddFeedback >
          </ModalBody>
        </Modal>
        <Container fluid>
          {/* <Nav>
            <NavItem>
              <NavLink href="https://astra.com/">astra</NavLink>
            </NavItem>
          </Nav> */}
          {/* <div className="copyright">
            © {new Date().getFullYear()} Introduced by Astra Innovations {" "}
            to elevate the game.
          </div> */}

          {/* <Button
            size="sm"
            color={"primary"}
            title={"Add Feedback Or Report Bug"}
            onClick={e => { this.toggleAddFeedback() }}
            className={"btn-icon pull-right feedback-modal"}

          >
            <i className={"tim-icons icon-chat-33"} />
          </Button> */}
        </Container>
      </footer>
    );
  }
}

export default Footer;
